import React, { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from 'redux/hooks';

import { ModalBasic } from 'components/commons/Modals';
import FeedForm from './FeedForm/FeedForm';
import { deleteFeedForm, getAllFeedsData, getFeedOptionsData, updateFeedData, restoreFeedForm, setIsNeedUpdateData } from 'redux/feeds/actions';
import { IFormFeedData } from 'redux/feeds/types';
import ComponentsLoader from 'components/ComponentsLoader/ComponentsLoader';

const frequency = [
    {
        planName: "Ozon S",
        frequency: 180,
        enable: true
    },
    {
        planName: "plan.names.plan_3",
        frequency: 180,
        enable: false
    },
    {
        planName: "plan.names.plan_2",
        frequency: 60,
        enable: false
    },
    {
        planName: "Ozon XS",
        frequency: 30,
        enable: false
    },
    {
        planName: "plan.names.plan_5",
        frequency: 10,
        enable: false
    },
]

const FeedWrapper = () => {

    const [allFeedsData, setAllFeedsData] = useState<IFormFeedData[] | []>([]);
    const [isFirstRender, setIsFirstRender] = useState<boolean>(true);

    const dispatch = useAppDispatch();

    const {isFeedModalOpen, sellerId, feedOptions, feeds, userId} = useAppSelector(({forms, sellers, feeds, users}) => ({
        isFeedModalOpen: forms.formFeedModalOpen,
        sellerId: sellers.currentSeller.info.data?.id,
        feedOptions: feeds.feed,
        feeds: feeds.feed.data.data,
        userId: users.currentUser.info.id
    }));

    const closeFeedModalHandler = () => {
        dispatch({
            type:"SET_FORM_MODAL_FEED_OPEN",
            payload: false
        })
    }

    const updateFeedDataHandler = (data: IFormFeedData) => {
        setIsFirstRender(false);
        dispatch(updateFeedData(data) as any);
        dispatch(setIsNeedUpdateData(true));
    }

    const deleteFeedHandler = (id: number) => {
        setAllFeedsData(prevState => {
            return prevState.map((element) =>
                element.id !== id ? element : {...element, isDeleted: true}
            )
        });
        dispatch(deleteFeedForm(id) as any);
    }

    const restoreFeedHandler = (id: number) => {
        setAllFeedsData(prevState => {
            return prevState.map((element) =>
                element.id !== id ? element : {...element, isDeleted: false}
            )
        });
        dispatch(restoreFeedForm(id) as any);
    }

    useEffect(() => {
        if(sellerId && isFeedModalOpen) {
            dispatch(getFeedOptionsData(sellerId) as any);
            dispatch(getAllFeedsData(sellerId) as any);
        }
        dispatch(setIsNeedUpdateData(false));

    }, [sellerId, isFeedModalOpen, feedOptions.options.isNeedUpdateData]);

    useEffect(() => {
        if(feeds) {
            setAllFeedsData(feeds);
        }
    }, [feeds])

    return (
        <ModalBasic
            id="formfeedmodal"
            title={"Генератор YML/XML"}
            modalOpen={isFeedModalOpen}
            setModalOpen={closeFeedModalHandler}
        >
            {
                feedOptions.options.isLoading && isFirstRender ? <div className='my-4'><ComponentsLoader /></div>
                :
                feedOptions.options.error ? <div className='text-center text-red-500 my-2' data-testid={"feedwrapper-error"}>{feedOptions.options.error}</div>
                :
                sellerId && userId && feedOptions.options &&
                <FeedForm
                    feeds={allFeedsData}
                    setFeedData={setAllFeedsData}
                    data-testid={"feedform-test"}
                    markets={feedOptions.options.data ? feedOptions.options.data.formats : []}
                    filters={feedOptions.options.data ? feedOptions.options.data.filters : []}
                    frequency={frequency}
                    sellerId={sellerId}
                    userId={userId}
                    updateFeedDataHandler={updateFeedDataHandler}
                    deleteFeedHandler={deleteFeedHandler}
                    restoreFeedHandler={restoreFeedHandler}
                />
            }
            
        </ModalBasic>
    )
}

export default FeedWrapper;